'use client';

import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/Dialog';
import { X, Play } from 'lucide-react';

export default function VideoModal({ isOpen, onClose, videoUrl, teacherName }) {
  if (!videoUrl) return null;

  // Determine video type and create appropriate embed
  const getVideoEmbed = (url) => {
    // YouTube video detection
    if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
      const videoId = url.includes('youtube.com/watch') 
        ? url.split('v=')[1]?.split('&')[0]
        : url.split('youtu.be/')[1]?.split('?')[0];
      
      if (videoId) {
        return (
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        );
      }
    }

    // Vimeo video detection
    if (url.includes('vimeo.com/')) {
      const videoId = url.split('vimeo.com/')[1]?.split('/')[0];
      if (videoId) {
        return (
          <iframe
            className="w-full h-full"
            src={`https://player.vimeo.com/video/${videoId}?autoplay=1`}
            title="Vimeo video player"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        );
      }
    }

    // Direct video file (mp4, webm, etc.)
    return (
      <video
        className="w-full h-full"
        controls
        autoPlay
        playsInline
        src={url}
      >
        Your browser does not support the video tag.
      </video>
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="max-w-4xl w-full p-0 bg-black"
        showCloseButton={false}
      >
        {/* Custom close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 rounded-full bg-black/50 hover:bg-black/70 text-white p-2 transition-colors"
          aria-label="Close video modal"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Video container */}
        <div className="relative aspect-video w-full bg-black rounded-lg overflow-hidden">
          {getVideoEmbed(videoUrl)}
        </div>

        {/* Video title */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
          <h3 className="text-white text-lg font-semibold">
            Introduction Video - {teacherName}
          </h3>
        </div>
      </DialogContent>
    </Dialog>
  );
}